import {
	Component,
	Input,
	Output,
	OnInit,
	EventEmitter,
	ViewChild,
	ElementRef,
	AfterContentChecked
} from '@angular/core';
import * as jQuery from 'jquery';
import * as numeral from 'numeral';
import * as _ from 'underscore';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-r5-devices',
	styleUrls: ['./r5-devices.component.css'],
	templateUrl: './r5-devices.component.html'
})
export class R5DevicesComponent implements OnInit, AfterContentChecked {
	@Input() sectiontitle: string;
	@Input() sortdataby: any;
	@Input() key: string;
	@Input() legend: any;
	@Input() downloadconfig: any;
	@Input() sectionclass: any;
	@Output() emitData: EventEmitter<any> = new EventEmitter<any>();
	@Output() legendSelected = new EventEmitter<any>();
	@Input() downloadcsvcolumns: any;
	@Input() piechartconfiguration: any;
	@Input() columnsconfig: any;
	@Input() barchartconfiguration: any;
	public primaryColor;
	public secondaryColor;
	public colorPalette: ColorPalette;
	public selectedMetrics: any;
	public selectedLegend: any;
	public showLoad: any;
	public hasData: any;
	public legendDisabled = false;
	public reloadSubscription: any;
	public downloadConfiguration: DownloadConfig;
	public groupByData: any;
	public donutData: any;
	public responseData: any;
	public downloadCSVColumns: any;
	public chartConfigObj = {
		svgHeight: 240,
		svgWidth: 190,
		seriesName: 'Devices',
		xLegendPos: 0,
		yLegendPos: 0,
		innerSize: '80',
		tooltipColor: '#FFF',
		tooltipTextColor: '#000',
		tooltipFontSize: '12px',
		followPointer: false,
		showPercentageToolTip: false,
		addSeriesNameToLables: true,
		size: 200,
		verticalAlign: 'bottom',
		legendText: '',
		datalabelsEnabled: false,
		dataLabelsDistance: 5,
		lineBreak: undefined,
		isTooltipEnabled: true,
		margin: [20, 20, 20, 20],
		type: 'pie',
		legendItemDistance: 100,
		enableCustomLegend: true,
		customLegendData: undefined,
		tooltipBackgroundColor: '#fff',
		devicesTooltip: true,
		tooltipFloatValue: '',
		events: {},
		pieBorderWidth: 0,
		tooltipRadius: null
	};
	public seriesData: any;
	public isR9: boolean;

	@ViewChild('chartElement') chartElement: ElementRef;

	constructor(private analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngAfterContentChecked(): void {
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r11') {
			jQuery('.legend_item_dev').css({ color: '#2e2e2e' });
		} else {
			jQuery('.legend_item_dev').css({ color: '#fff' });
		}
		jQuery('.item_selected').css({ color: this.colorPalette.primaryColor });
	}

	ngOnInit(): void {
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		this.barchartconfiguration = JSON.parse(decodeURI(this.barchartconfiguration));
		this.legend = JSON.parse(decodeURI(this.legend));
		this.legend = _.filter(this.legend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.piechartconfiguration = JSON.parse(decodeURI(this.piechartconfiguration));
		this.chartConfigObj.innerSize = this.sectionclass.split(' ')[0] == 'devices-r11' ? '85' : '80';
		this.chartConfigObj.tooltipRadius = this.sectionclass.split(' ')[0] == 'devices-r11' ? 0 : null;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.columnsconfig = JSON.parse(decodeURI(this.columnsconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.chartConfigObj.events = {
			// tslint:disable-next-line:typedef
			load() {
				const graph = this.series[0].data[1].graphic;
				setTimeout(() => {
					if (graph) {
						graph.attr({
							innerR: 55
						});
					}
				}, 200);
			}
		};
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.primaryColor = this.colorPalette.primaryColor;
		this.secondaryColor = this.colorPalette.secondaryColor;
		this.setCustomPieChartConfig();
		this.processLegendData();
		this.requestData();
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = response.data.length > 0 ? true : false;
				this.responseData = response.data;
				this.processDonutData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}

	processDonutData(respData: any): void {
		this.donutData = [];
		this.groupByData = _.map(respData, (item) => {
			return {
				device: item['device'],
				[this.selectedMetrics]: item[this.selectedMetrics]
			};
		});
		const currentMetricTotal = this.groupByData.reduce((s, f) => {
			return s + Number(f[this.selectedMetrics]);
		}, 0);
		_.each(this.groupByData, (item) => {
			const frmt =
				numeral((Number(item[this.selectedMetrics]) / currentMetricTotal) * 100).format('0, 0.00') === '100.00'
					? '0'
					: '0,0.00';
			const percentage = numeral((Number(item[this.selectedMetrics]) / currentMetricTotal) * 100).format(frmt);
			const donutTotal = currentMetricTotal - Number(item[this.selectedMetrics]);
			this.chartConfigObj.isTooltipEnabled = !this.selectedLegend.tootlTipEnabled
				? this.selectedLegend.tootlTipEnabled
				: true;
			const ctvMapper = this.columnsconfig.filter((obj1) => obj1.key === 'Connected TV');
			const obj = {
				chartConfigurationObj: this.chartConfigObj,
				percent: percentage,
				seriesData: (this.seriesData = [
					{
						color: this.sectionclass.split(' ')[0] === 'devices-r11' ? this.primaryColor : this.primaryColor,
						name: this.selectedLegend.displayName,
						y: Number(item[this.selectedMetrics])
					},
					{
						color: this.sectionclass.split(' ')[0] === 'devices-r11' ? '#ffffff' : '#d8d8d8',
						name: this.selectedLegend.displayName,
						y: donutTotal
					}
				]),
				title: ctvMapper.length > 0 && item['device'] === ctvMapper[0].key ? ctvMapper[0].name : item['device']
			};
			this.donutData.push(obj);
		});
		this.donutData = this.sortdataby ? _.sortBy(this.donutData, this.sortdataby) : this.donutData;
		if (this.sectionclass.split(' ')[0] == 'devices-r11') {
			let OtherDevice;
			this.donutData.forEach((device, index) => {
				if (device.title == 'Other') {
					OtherDevice = this.donutData.splice(index, 1);
				}
			});
			if (OtherDevice) {
				this.donutData.push(OtherDevice[0]);
			}
		}
		this.renderChart();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}

	renderChart(): void {
		this.seriesData = [
			{
				color: this.primaryColor,
				name: 'Impressions',
				y: 257763
			},
			{
				color: '#d8d8d8',
				name: 'Total Imressions',
				y: 45251
			}
		];
	}

	selectLegendItem(legendItem: any): void {
		this.selectedMetrics = legendItem.value;
		for (const legendObj of this.legend) {
			legendObj['selected'] = false;
		}
		const index = this.legend.findIndex((x) => x.value === this.selectedMetrics);
		this.legend[index].selected = true;
		this.selectedLegend = this.legend[index];
		this.chartConfigObj.tooltipFloatValue = this.selectedLegend.isFloat;
		this.processDonutData(this.responseData);
	}

	processLegendData(): void {
		for (const legendObj of this.legend) {
			legendObj['selected'] = false;
		}
		this.selectedMetrics = this.legend[0].value;
		this.legend[0].selected = true;
		this.selectedLegend = this.legend[0];
		this.chartConfigObj.tooltipFloatValue = this.selectedLegend.isFloat;
		this.processDonutData(this.responseData);
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	setCustomPieChartConfig(): void {
		if (this.isR9) {
			this.chartConfigObj.tooltipBackgroundColor = this.barchartconfiguration.tooltip.backgroundColor
				? this.barchartconfiguration.tooltip.backgroundColor
				: '#FFF';
			this.chartConfigObj.tooltipTextColor = this.barchartconfiguration.tooltip.textColor
				? this.barchartconfiguration.tooltip.textColor
				: '#000';
			this.chartConfigObj.tooltipRadius = this.barchartconfiguration.tooltip.borderRadius
			    ? this.barchartconfiguration.tooltip.borderRadius : 5;
		}
		if (this.piechartconfiguration) {
			this.chartConfigObj = { ...this.chartConfigObj, ...this.piechartconfiguration };
		}
	}
}
